export default __webpack_public_path__ + "static/media/client-12.4ea16435.webp";